export default __webpack_public_path__ + "static/media/card-unionpay.35284e96.svg";